module.exports = __webpack_public_path__ + "static/image1-c0054f4d21f924e2221ffeb5bc07316f.jpg";